// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"4b71e0f2","284":"e3022f9c"}[chunkId] + ".chunk.css";
};